import { IEtap } from "./IEtap"
import { ITechnologia } from "./ITechnologia"
import { Technologia } from "./Technologia"


export class Etap implements IEtap {
    /*
    [id] [int] IDENTITY(1,1) NOT NULL,
	[kalk_id] [int] NULL,
	[typ] [nvarchar](40) NULL,
	[grupa_maszyn] [char](3) NULL,
	[list_order] [int] NULL,
    */
    etap_id:number|undefined
	etap_op_id: any
	kalk_id:number|undefined

	etap_typ:string="etap"
	nazwa:string=""

	grupa_maszyn:string=""
	list_order:number=0
	predkosc:number=0

	technologie: ITechnologia[]=[]

	rodzaj_farby:string="";
	rodzaj_lakieru:string="";
	kolory_studio:string[]=[];
	static etap_rodzaje_farby:string[]=["UV","UV_LM","LED_LM","WODA" ]
	static etap_rodzaje_lakieru:string[]=["UV","UV_LM","LED_LM","WODA"  ]
	
	static etap_kolory_studio:string[]=[
	"Cyan",
	"Magenta",
	"Yellow",
	"Black",
	"Cyan",
	"Magenta",
	"Yellow",
	"Black",
	"Cyan",
	"Magenta",
	"Yellow",
	"Black",
	"PANTONE*",
	"BIALY*",
	"LAKIER(VARNISH) GLOSS",
	"LAKIER(VARNISH) MATT",
	"LAKIER TTR GLOSS",
	"LAKIER TTR MATT",
	"SITO BIALY",
	"SITO*",
	"SILIKON",
	"LACZENIE",
	"CS SILVER",
	"CS GOLD",
	"CS FOLIA",
	"HS GOLD",
	"HS SILVER",
	"HS FOLIA",
	"PRIMER",
	"MD SITO 125W",
	"MD SILVER",
	"MD GOLD",
	"MD FOLIA",
	"SITO PUCHN LAKIER DW",
	"SITO PUCHN 125W",
	"SITO PUCHN HV",
	"SITO PUCHN BZ",
	"SITO PUCHN BY",
	"WOLNY*"
	]
	
	constructor () {}

}

export type EtapFilled = {
    /*
    [id] [int] IDENTITY(1,1) NOT NULL,
	[kalk_id] [int] NULL,
	[typ] [nvarchar](40) NULL,
	[grupa_maszyn] [char](3) NULL,
	[list_order] [int] NULL,
    */
    etap_id:number|undefined
	kalk_id:number|undefined

	etap_typ:string,
	nazwa:string,

	grupa_maszyn:string
	list_order:number
	predkosc:number;
	technologie: Technologia[]

	rodzaj_farb:string;
	kolory_studio:string[];

}